import { IFilterField } from '@/components/organism/filters/types';
import { FilterFields, FilterFieldsProps, IEditableRequestsFilters, IRequestsFilters } from './types';
import { buildBranchOptions, buildMonthOptions, buildReportTypes, buildStatusOptions, buildTrimesterOptions, buildYearOptions } from './utils';

export const INITIAL_FILTERS: IRequestsFilters = {
  companyId: '',
  controlZoneId: '',
  month: '',
  year: '',
  reporttype: '',
  branchId: '',
  trimester: '',
  status: undefined,
  code: '',
  requestNumber: '',
  seguredName: '',
  modifyType: -1,
  policy_number: '',
  licenseplate: '',
};

const getAllFilterFields = ({ statuses, branches, trimesters }: FilterFieldsProps): FilterFields => ({
  seguredName: {
    type: 'text',
    key: 'seguredName',
    label: 'Asegurado',
    placeholder: 'Buscar por asegurado',
  },
  branchId: ({
    type: 'select',
    key: 'branchId',
    label: 'Ramo',
    placeholder: 'Ramo',
    options: buildBranchOptions(branches),
  }),
  status: ({
    type: 'select',
    key: 'status',
    label: 'Estado',
    placeholder: 'Estado',
    options: buildStatusOptions(statuses),
  }),
  month: {
    type: 'select',
    key: 'month',
    label: 'Mes',
    placeholder: 'Mes',
    options: buildMonthOptions(),
  },
  address: {
    type: 'text',
    key: 'address',
    label: 'Dirección',
    placeholder: 'Dirección',
  },
  reporttype: {
    type: 'select',
    key: 'reporttype',
    label: 'Tipo de Reporte',
    placeholder: 'Tipo de Reporte',
    options: buildReportTypes(),
  },
  year: {
    type: 'select',
    key: 'year',
    label: 'Año',
    placeholder: 'Año',
    options: buildYearOptions(),
  },
  requestNumber: {
    type: 'text',
    key: 'requestNumber',
    label: 'Número de Solicitud',
    placeholder: 'Número de Solicitud',
  },
  trimester: ({
    type: 'select',
    key: 'trimester',
    label: 'Trimestre',
    placeholder: 'Trimestre',
    options: buildTrimesterOptions(trimesters),
  }),
  policy_number: {
    type: 'text',
    key: 'policy_number',
    label: 'Número de Póliza',
    placeholder: 'Número de Póliza',
  },
  code: {
    type: 'text',
    key: 'code',
    label: 'Código de Solicitud',
    placeholder: 'Código de Solicitud',
  },
  licenseplate: {
    type: 'text',
    key: 'licenseplate',
    label: 'Patente',
    placeholder: 'Patente',
  },
});

const getFilterFields = (props: FilterFieldsProps, keys?: (keyof IEditableRequestsFilters)[]): IFilterField<IEditableRequestsFilters>[] => {
  const allFields = getAllFilterFields(props);
  return keys ? keys.map(key => allFields[key]) : Object.values(allFields);
};

export default getFilterFields;